import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import FirstSectionPanel from '../SummaryDataCollectionGroup/FirstSectionPanel.js';
import SecondSectionPanel from '../SummaryDataCollectionGroup/SecondSectionPanel.js';
import ThirdSectionPanel from './ThirdSectionPanel.js';
import FourSectionPanel from './FourSectionPanel.js';
import FiveSectionPanel from './FiveSectionPanel.js';
import SixSectionPanel from './SixSectionPanel.js';


export default class BeamlineDataCollectionGroupPanel extends React.Component {                   
    render() {          
        return <Grid fluid style={{marginTop:'15px'}}>                   
                    <Row>
                         <Col  xs={12} sm={6} md={2}>
                                <FirstSectionPanel datacollectiongroup={this.props.datacollectiongroup}></FirstSectionPanel>
                        </Col>
                        <Col  xs={12} sm={6} md={2}>
                                <SecondSectionPanel datacollectiongroup={this.props.datacollectiongroup}></SecondSectionPanel>
                        </Col>
                        <Col  xs={12} sm={6} md={2}>                        
                                <ThirdSectionPanel datacollectiongroup={this.props.datacollectiongroup}></ThirdSectionPanel>
                        </Col>
                        <Col  xs={12} sm={6} md={2}>
                               <FourSectionPanel {...this.props}></FourSectionPanel>
                        </Col>
                        <Col  xs={12} sm={6} md={2}>
                                <FiveSectionPanel {...this.props}></FiveSectionPanel>
                        </Col>
                        <Col  xs={12} sm={6} md={2}>
                                <SixSectionPanel {...this.props}></SixSectionPanel>
                        </Col>
                    </Row>                    
            </Grid>;
    }
}





// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/BeamlineDataCollectionGroup/BeamlineDataCollectionGroupPanel.js